<template>
    <div class="flat-crm-card" v-if="cardData != null && flatsPage != null">
        <div class="container">
            <div class="card-title">
                <h1 :class="{'not-first' : cardData.rooms != 1}"><span>{{cardData.rooms}}</span> {{flatsPage.flats_cards_info.flat_modal_title}}</h1>
                <div class="btns-container" v-if="!isMobileChecker && complexData != null">
                    <SWhatsApp class="link-social"
                        :share-options="{
                            text: 'Ваша ' + cardData.rooms + '-комнатная квартира ' +  cardData.area + 'м², в жилом комплексе ' +  complexData.project_name.name + ', ' + 'https://sales.bazis.kz/flats/' + cardData.id
                        }"
                        :use-native-behavior="true"
                    ><svgIcon name="wapp" class="icon-wapp"/></SWhatsApp>
                    <STelegram class="link-social"
                        :share-options="{
                            text: 'Ваша ' + cardData.rooms + '-комнатная квартира ' +  cardData.area + 'м², в жилом комплексе ' +  complexData.project_name.name,
                            url: 'https://sales.bazis.kz/flats/' + cardData.id
                        }"
                        :use-native-behavior="true"
                    ><svgIcon name="telapp" class="icon-telapp"/></STelegram>
                    <a :href="complexData.project_site_in.link + '?utm_source=sales.bazis.kz&utm_medium=apartment&utm_campaign=web'" class="card-link link-project" target="_blank" v-if="complexData != null">
                        <svgIcon name="login" class="icon-login"/>
                        <span>{{flatsPage.flats_cards_info.flat_btn_look_project}}</span>
                    </a>
                    <a :href="ucoCRMurl + '/rest/prices/getImage?imageId=' + pdf" download target="_blank" v-if="pdf != null" class="card-link donwload-pdf">
                        <svgIcon name="print" class="icon-print"/>
                        <span>{{flatsPage.flats_cards_info.flat_btn_download_flat_name}}</span>
                    </a>
                    <a href="#" v-if="pdf != null" class="card-link send-mail" @click.prevent="openFormMailFlatsCRM">
                        <svgIcon name="mail" class="icon-mail"/>
                        <span>{{flatsPage.flats_cards_info.flat_btn_mail_send_name}}</span>
                    </a>
                </div>
            </div>
            <!-- Мобильная шапка карточки -->
            <div class="card-header-mobile" v-if="isMobile">
                <div class="card-complex" v-if="complexData != null">
                    <div class="complex-info">
                        <div class="complex-logo">
                            <img :src="complexData.logo_color" alt="">
                        </div>
                        <div class="complex-info-right">
                            <p>{{complexData.city_name.name}}</p>
                            <a href="#" :class="{'active' : openMapFlatsCrmCard}" @click.prevent="$store.commit('openMapFlatsCrmCard', !openMapFlatsCrmCard)">{{flatsPage.flats_cards_info.flat_btn_show_on_map_name}}</a>
                        </div>
                    </div>
                </div>
            </div>
            <!-- end мобильная шапка карточки -->
            <div class="flat-card-info">
                <div class="col-left">
                    <transition name="fade" mode="out-in">
                        <div class="flats-crm-card-mail-form" v-if="complex != null && complexData != null && !isMobileChecker && openFormMailFlatsCrm">
                            <a href="#" @click.prevent="closeFormMailFlatsCRM" class="link-close">
                                <svgIcon name="close" class="icon-close"/>
                            </a>
                            <div class="form-container">
                                <formMailFlat :options="[{flat_link: 'https://sales.bazis.kz/flats/' + cardData.id, project_name:  complex, pdf: 'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pdf, name: cardData.rooms + ' ком. квартира ' +  cardData.area + 'м²' + ' в ' + CapitalizeID(complexData.project_name.name) + '.pdf'}]" v-if="complexData != null"></formMailFlat>
                            </div>
                        </div>
                    </transition>
                    <div class="col-content">
                        <div class="card-img" v-if="!openMapFlatsCrmCard">
                            <div class="img-in" v-if="cardData.images.length > 0">
                                <img :src="'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pic.id" v-for="(pic, index) in cardData.images.filter(item => item.typeCode === '1')" :key="index">
                            </div>
                            <div class="btn-to-favorite">
                                <a href="#" class="favorite-link" @click.prevent="sendToFavorite(cardData.id), checkerClass($event)" :class="{'active' : checkProjectFavorite(cardData.id)}">
                                    <!-- <svgIcon name="star" className="icon-star"/> -->
                                    <svgIcon name="star-sales" class="icon-star"/>
                                </a>
                            </div>
                            <div class="btns-to-img">
                                <a href="#" class="loop-img link-default" @click.prevent="openLoopCardImg(cardData.images)" v-if="cardData.images.length > 0">
                                    <svgIcon name="loop" class="icon-loop"/>
                                </a>
                            </div>
                        </div>
                        <div class="card-map" v-if="openMapFlatsCrmCard && complexData != null">
                            <flatsCardMap :cardData="complexData"></flatsCardMap>
                        </div>
                    </div>
                    <div class="col-left-bot">
                        <div class="card-images">
                            <div class="col col-part" v-for="(pic) in cardData.images.filter(item => item.typeCode === '3')" :key="pic.id"> 
                                <img :src="'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pic.id">
                            </div>
                            <div class="col col-plan" v-for="(pic) in cardData.images.filter(item => item.typeCode === '2')" :key="pic.id"> 
                                <img :src="'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pic.id">
                            </div>
                            <div class="col col-rose" v-for="(pic) in cardData.images.filter(item => item.typeCode === '4')" :key="pic.id"> 
                                <img :src="'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pic.id">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-right">
                    <div class="card-complex" v-if="complexData != null && !isMobile">
                        <div class="complex-info">
                            <div class="complex-logo">
                                <img :src="complexData.logo_color" alt="">
                            </div>
                            <div class="complex-info-right">
                                <p>{{complexData.city_name.name}}</p>
                                <a href="#" :class="{'active' : openMapFlatsCrmCard}" @click.prevent="$store.commit('openMapFlatsCrmCard', !openMapFlatsCrmCard)">{{flatsPage.flats_cards_info.flat_btn_show_on_map_name}}</a>
                            </div>
                        </div>
                    </div>
                    <div class="card-info">
                        <ul>
                            <li>
                                <div class="left">
                                    {{flatsPage.flats_cards_info.flat_object_name}}
                                </div>
                                <div class="right" v-if="cardData.complexCode != 'LDM' && cardData.complexCode != 'LDM-II' && cardData.complexCode != 'LDM-III' && cardData.complexCode != 'LDM-IV'">
                                    {{cardData.complexName.replace(/['"]+/g, '')}}
                                </div>
                                <div class="right" v-else>
                                    {{cardData.complexName.replace(/\,.*/,'')}}
                                </div>
                            </li>
                            
                            <li>
                                <div class="left">
                                    {{flatsPage.flats_cards_info.flat_size}}
                                </div>
                                <div class="right">
                                    {{cardData.area}} <span>м²</span>
                                </div>
                            </li>
                            <li class="price" v-if="cardData.showPricesOnSaleSite == true">
                                <div class="left">
                                    {{flatsPage.flats_cards_info.flat_price}} м²
                                </div>
                                <div class="right">
                                    <span v-if="globalLang == ''">от</span><span v-if="globalLang == 'en/'">from</span>
                                    {{getNumber(cardData.meterPrice)}} 
                                    <span v-if="globalLang == ''">тг.</span><span v-if="globalLang == 'en/'">tg</span><span v-if="globalLang == 'kz/'">тг.бас.</span>
                                </div>
                            </li>
                            <li class="price" v-if="cardData.showPricesOnSaleSite == true">
                                <div class="left">
                                    {{flatsPage.flats_cards_info.flat_full_price}}
                                </div>
                                <div class="right">
                                    <span v-if="globalLang == ''">от</span><span v-if="globalLang == 'en/'">from</span>
                                    {{getNumber(cardData.totalPrice)}} 
                                    <span v-if="globalLang == ''">тг.</span><span v-if="globalLang == 'en/'">tg.</span><span v-if="globalLang == 'kz/'">тг.бас.</span>
                                </div>
                            </li>
                            <li>
                                <div class="left">
                                    {{flatsPage.flats_cards_info.flat_rooms}}
                                </div>
                                <div class="right">
                                    {{cardData.rooms}} 
                                </div>
                            </li>
                            <li>
                                <div class="left">
                                    {{flatsPage.flats_cards_info.flat_floor}}
                                </div>
                                <div class="right">
                                    {{cardData.floor}}
                                </div>
                            </li>
                            <li>
                                <div class="left">
                                    {{flatsPage.flats_cards_info.flat_flat_number}}
                                </div>
                                <div class="right">
                                    {{cardData.number}}
                                </div>
                            </li>
                            <li>
                                <div class="left">
                                    <span v-if="cardData.complexCode != 'SOH'">{{flatsPage.flats_cards_info.flat_bloom}}</span>
                                    <span v-else>{{flatsPage.flats_cards_info.flat_kvartal}}</span>
                                </div>
                                <div class="right" v-if="cardData.complexCode != 'DSV' && cardData.complexCode != 'LDM' && cardData.complexCode != 'LDM-II' && cardData.complexCode != 'LDM-III' && cardData.complexCode != 'LDM-IV' && cardData.complexCode != 'SOH' && cardData.complexCode != 'MNC'">
                                    {{getNumbersOfString(cardData.blockName)}}
                                </div>
                                <div class="right" v-if="cardData.complexCode == 'DSV'">
                                    {{getNumbersOfBlockDiscovery(cardData.blockName)}}
                                </div>
                                <div class="right" v-if="cardData.complexCode == 'LDM' || cardData.complexCode == 'LDM-II' || cardData.complexCode == 'LDM-III' || cardData.complexCode == 'LDM-IV'">
                                    {{getNumbersOfBlockLandmark(cardData.blockName)}}
                                </div>
                                <div class="right" v-if="cardData.complexCode == 'SOH'">
                                    {{getNumbersOfBlockSoho(cardData.blockName)}}
                                </div>
                                <div class="right" v-if="cardData.complexCode == 'MNC'">
                                    {{getNumbersOfBlockMonaco(cardData.blockName)}}
                                </div>
                            </li>
                            <li v-if="blockPart != null">
                                <div class="left">
                                    <span v-if="cardData.complexCode != 'SOH' && cardData.complexCode != 'MNC'">{{flatsPage.flats_cards_info.flat_part}}</span>
                                    <span v-else>{{flatsPage.flats_cards_info.flat_block}}</span>
                                </div>
                                <div class="right" v-if="cardData.complexCode == 'LDM' || cardData.complexCode == 'LDM-II' || cardData.complexCode == 'LDM-III' || cardData.complexCode == 'LDM-IV' || cardData.complexCode == 'SOH' || cardData.complexCode == 'MNC'">
                                    {{ blockPart }}
                                </div>
                            </li>
                            <li v-if="cardData.commissioningDate != null">
                                <div class="left">
                                    {{flatsPage.flats_cards_info.flat_finish_time}}
                                </div>
                                <div class="right" v-if="globalLang == ''">
                                    {{getCorrectFinishTime(cardData.commissioningDate)}} <span>квартал</span> {{cardData.commissioningDate.split('-')[0]}} г.
                                </div>
                                <div class="right" v-if="globalLang == 'kz/'">
                                    {{getCorrectFinishTime(cardData.commissioningDate)}} <span>тоқсан </span> {{cardData.commissioningDate.split('-')[0]}} ж.
                                </div>
                                <div class="right" v-if="globalLang == 'en/'">
                                    {{getCorrectFinishTime(cardData.commissioningDate)}} <span>quarter</span> {{cardData.commissioningDate.split('-')[0]}}
                                </div>
                            </li>
                        </ul>
                    </div>
                    <!-- Мобильные кнопки -->
                    <div class="col-left-bot-links-mobile" v-if="isMobile">
                        <a :href="complexData.project_site_in.link + '?utm_source=sales.bazis.kz&utm_medium=apartment&utm_campaign=web'" class="card-link link-project" target="_blank" v-if="complexData != null">
                            <svgIcon name="login" class="icon-login"/>
                            <!-- <span>Посмотреть проект</span> -->
                        </a>
                        <a href="#" v-if="pdf != null" class="card-link send mail" @click.prevent="$store.commit('openFormMailFlatsCRM_mobileSet', !openFormMailFlatsCrm_mobile)">
                            <svgIcon name="mail" class="icon-mail"/>
                            <!-- <span>Получить на почту</span> -->
                        </a>
                        <a :href="ucoCRMurl + '/rest/prices/getImage?imageId=' + pdf" download target="_blank" v-if="pdf != null" class="card-link donwload-pdf">
                            <svgIcon name="print" class="icon-print"/>
                            <!-- <span>СКАЧАТЬ ПЛАНИРОВКУ</span> -->
                        </a>
                        <SWhatsApp
                            :share-options="{
                                text: 'Ваша ' + cardData.rooms + '-комнатная квартира ' +  cardData.area + 'м², в жилом комплексе ' +  complexData.project_name.name + ', ' + 'https://sales.bazis.kz/flats/' + cardData.id
                            }"
                            :use-native-behavior="true"
                        ><svgIcon name="wapp" class="icon-wapp"/></SWhatsApp>
                        <STelegram
                            :share-options="{
                                text: 'Ваша ' + cardData.rooms + '-комнатная квартира ' +  cardData.area + 'м², в жилом комплексе ' +  complexData.project_name.name,
                                url: 'https://sales.bazis.kz/flats/' + cardData.id
                            }"
                            :use-native-behavior="true"
                        ><svgIcon name="telapp" class="icon-telapp"/></STelegram>
                        
                    </div>

                    <div class="form-mail-flat-crm-mobile" v-if="complex != null && complexData != null && isMobileChecker && openFormMailFlatsCrm_mobile">
                        <formMailFlat :options="[{flat_link: 'https://sales.bazis.kz/flats/' + cardData.id, project_name:  complex, pdf: 'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pdf, name: cardData.rooms + ' ком. квартира ' +  cardData.area + 'м²' + ' в ' + CapitalizeID(complexData.project_name.name) + '.pdf'}]" v-if="complexData != null"></formMailFlat>
                    </div>
                    <!-- end мобильные кнопки -->
                    <div class="card-links" v-if="complexData != null">
                        <!-- {{complexData.project_name }} -->
                        <!-- {{cardData.blockName}} -->
                        <div class="links">
                            <a 
                                :href="URLrocketLC + '/?apartment_id=' + cardData.id + '&city=' + complexData.city_name.slug + '&method=book&lang=' + langVAR" class="bron" target="_blank" 
                                @click.prevent="linkToLogin(URLrocketLC + '/?apartment_id=' + cardData.id + '&city=' + complexData.city_name.slug + '&method=book&lang=' + langVAR, 'book')"
                                v-if="cardData.isApartmentReserved"
                                >{{flatsPage.flats_cards_info.flat_btn_book_name}}
                            </a>
                            <span v-else class="btn-off bron-off">{{flatsPage.flats_cards_info.flat_btn_book_name}}</span>
                            <a 
                                :href="URLrocketLC + '/?apartment_id=' + cardData.id + '&city=' + complexData.city_name.slug + '&method=by&lang=' + langVAR" class="by" target="_blank" 
                                @click.prevent="linkToLogin(URLrocketLC + '/?apartment_id=' + cardData.id + '&city=' + complexData.city_name.slug + '&method=by&lang=' + langVAR, 'by')" 
                                v-if="cardData.hasJointVentureAgreement"
                                >{{flatsPage.flats_cards_info.flat_btn_by_now_name}}
                            </a>
                            <span v-else class="btn-off by-off">{{flatsPage.flats_cards_info.flat_btn_by_now_name}}</span>
                        </div>
                        <!-- <div class="links" v-else>
                            <a 
                                :href="URLrocketLC + '/?apartment_id=' + cardData.id + '&city=' + complexData.city_name.slug + '&method=book&lang=' + langVAR" class="bron" target="_blank" 
                                @click.prevent="linkToLogin(URLrocketLC + '/?apartment_id=' + cardData.id + '&city=' + complexData.city_name.slug + '&method=book&lang=' + langVAR, 'book')"
                                v-if="checkConfirmPurchase('book', cardData.complexCode, cardData.blockName)"
                                >{{flatsPage.flats_cards_info.flat_btn_book_name}}
                            </a>
                            <span v-else class="btn-off bron-off">{{flatsPage.flats_cards_info.flat_btn_book_name}}</span>
                            <a 
                                :href="URLrocketLC + '/?apartment_id=' + cardData.id + '&city=' + complexData.city_name.slug + '&method=by&lang=' + langVAR" class="by" target="_blank" 
                                @click.prevent="linkToLogin(URLrocketLC + '/?apartment_id=' + cardData.id + '&city=' + complexData.city_name.slug + '&method=by&lang=' + langVAR, 'by')" 
                                v-if="checkConfirmPurchase('by', cardData.complexCode, cardData.blockName)"
                                >{{flatsPage.flats_cards_info.flat_btn_by_now_name}}
                            </a>
                            <span v-else class="btn-off by-off">{{flatsPage.flats_cards_info.flat_btn_by_now_name}}</span>
                        </div> -->
                    </div>
                </div>
            </div>

            <div class="flats-card-payment-container" v-if="complexData != null && flatsPage != null && cardData.hasMortgage" id="flat-crm-card-online-payment">
                <div class="flats-card-payment-navigation">
                    <ul>
                        <!-- <li :class="{'active': crmCardPeymentSection == 'fullPay'}" @click.prevent="crmCardPeymentSection = 'fullPay'">Покупка</li> -->
                        <li :class="{'active': crmCardPeymentSection == 'hypothec'}" @click.prevent="crmCardPeymentSection = 'hypothec'">Ипотека</li>
                        <!-- <li :class="{'active': crmCardPeymentSection == 'partPay'}" @click.prevent="crmCardPeymentSection = 'partPay'">Рассрочка</li> -->
                    </ul>
                </div>
                <flatsCardPaymentHypothec :flatsCardParams="{'price': getNumber(cardData.totalPrice), 'price_meter' : getNumber(cardData.meterPrice), 'complexData' : complexData, 'appsID' : cardData.id}"></flatsCardPaymentHypothec>
            </div>
        </div>
        
        <formPage class="form-flat-card-crm"></formPage>
        <flatsViewedSection :cardData="cardData"></flatsViewedSection>
        <flatsCardImg v-if="cardImgVisible"></flatsCardImg>
        <!-- {{ complexData.project_name }} -->
        <transition name="fade" mode="out-in">
            <div class="flats-card-crm-overlay" @click="closeLoopCardImg()" v-cloak v-if="cardImgVisible"></div>
        </transition>
    </div>
</template>

<script>
	import flatsCardImg from '@/components/flats-crm/flats-crm-card-img.vue'
	import flatsCardMap from '@/components/flats-crm/flats-crm-card-map.vue'
	// import flatsCardForm from '@/components/forms/form-flats-crm-card.vue'

	import flatsCardPaymentHypothec from '@/components/flats-crm/flats-crm-card-payment-hypothec.vue'


	import flatsViewedSection from '@/components/flats-crm/flats-crm-viewed-flats.vue'
	import formMailFlat from '@/components/forms/form-mail-flat-crm.vue';	
	import formPage from '@/components/forms/form-page.vue';	

    import { STelegram, SWhatsApp } from 'vue-socials'

    import svgIcon from '@/components/partials/SvgIcon.vue';
    import {mapGetters} from 'vuex'
    import store from '@/store.js'
    // import cookie from 'vue-cookie'
    // var querystring = require('querystring');
    // const tokenAuthCrm = cookie.get('crm_auth_token');
    var cyrillicToTranslit = require("cyrillic-to-translit-js")
    export default {
        name: 'flat-crm-card',
        components: {
            // sharePostBottom,
            flatsCardImg,
            flatsCardMap,
            // flatsCardForm,
            flatsViewedSection,
            flatsCardPaymentHypothec,
            formMailFlat,
            formPage,
            svgIcon,
            SWhatsApp,
            STelegram,
        },
        data () {
            return {
                windowFeatures: {},
                shareOptions: {
                    url: 'https://github.com/',
                    text: 'Text',
                },
                useNativeBehavior: false,
                cardID: this.$route.params.id,
                globalLang: window.GlobalLang,
                cardData: null,
                pdf: null,
                complex: null,
                complexData: null,
                cardContent: 'image',
                formDataParams: null,
                isMobile: false,
                langVAR: window.LangVar,
                blockPart: null,
                crmCardPeymentSection: 'hypothec',
                // CRMbaseAuth: Buffer.from(`${'client'}:${'secret'}`, 'utf8').toString('base64'),
                // crmDATAsend: {
                //     "grant_type": "password",
                //     "username": "image",
                //     "password": "qazwsx"
                // },
            }
        },
        computed: mapGetters({
            flatsPage: 'loadFlatsPage',
            projectItems: 'loadProjectItemsDefault',
            cardImgVisible: 'loadVisibleCardImgWindow',
            URLrocketLC: 'loadUrlRocketLC',
            ucoCRMurl: 'loadUrlCRMuco',
            isMobileChecker: 'loadIsMobileChecker',
            openFormMailFlatsCrm: 'loadOpenFormMailFlatsCRM',
            openFormMailFlatsCrm_mobile: 'loadOpenFormMailFlatsCRM_mobile',
            openMapFlatsCrmCard: 'loadOpenMapFlatsCrmCard',
            // flatCard: 'loadFlatCard',
        }),
        methods: {
            openLoopCardImg(data) {
                this.$store.commit('setVisibleCardImgWindow', true);
                this.$store.commit('setCardImgData', data);
                window.body.addClass('overflowTrue');
                document.getElementById('header').classList.add('notvisible');
                document.getElementById('footer').classList.add('notvisible');
                if (this.banerTopCoockieVisible == true) {
                    document.getElementById('banerTopHorizont').classList.add('notvisible');
                }
            },
            closeLoopCardImg() {
                this.$store.commit('setVisibleCardImgWindow', false);
                this.$store.commit('setCardImgData', null);
                window.body.removeClass('overflowTrue');
                document.getElementById('header').classList.remove('notvisible');
                document.getElementById('footer').classList.remove('notvisible');
                if (this.banerTopCoockieVisible == true) {
                    document.getElementById('banerTopHorizont').classList.remove('notvisible');
                }
            },
            getNumbersOfString(str) {
                return str.replace(/[^0-9]+/g, "");
            },
            getNumber(n) {
                return String(n).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")
            },
            getNumbersOfBlockDiscovery(str) { 
                var parseStr = str.split(',')[0];
                return parseStr.replace('Пятно', '');
            },
            getNumbersOfBlockLandmark(str) {
                if (this.blockPart == null) {
                    this.blockPart = str.split(',')[1];
                    this.blockPart = parseInt(this.blockPart);
                }
                var parseStr = str.split(',')[0];
                return parseStr.replace('Пятно', '');
            },
            getNumbersOfBlockSoho(str) {
                if (this.blockPart == null) {
                    this.blockPart = str.split(',')[1];
                    this.blockPart = this.blockPart.replace('Блок', '');
                    this.blockPart = this.blockPart.replace(/ /g, '');

                }
                var parseStr = str.split(',')[0];
                return parseStr.replace('Квартал', '').replace(/ /g, '');
            },
            getNumbersOfBlockMonaco(str) {
                if (this.blockPart == null) {
                    this.blockPart = str.split(',')[1];
                    this.blockPart = this.blockPart.replace('Блок', '');
                    this.blockPart = this.blockPart.replace(/ /g, '');

                }
                var parseStr = str.split(',')[0];
                return parseStr.replace('Пятно', '').replace(/ /g, '');
            },
            getFullPrice(price, area) {
                const result = price * area;
                return this.getNumber(parseInt(result));
            },
            getPriceForm() {

            },
            getCorrectFinishTime(date) {
                var parseDate = parseInt(date.split('-')[1]);
                // console.log(parseDate, 'asdasdasdasdas')
                if (parseDate <= 3) {
                    return '1';
                } else if (parseDate > 3 && parseDate <= 6) {
                    return '2';
                } else if (parseDate > 6 && parseDate <= 9) {
                    return '3';
                } else {
                    return '4';
                }
            },
            startLoader() {
                // this.$parent.$parent.$refs.topProgress.start();
            },
            openFormModal(param) {
                this.$store.commit('Open_Form_Modal', param);
            },
            getIdPDF(arr) {
                var filItem = arr.filter(item => {
                    return item.typeCode == '5'
                });
                if (filItem.length) 
                this.pdf = filItem[0].id;
                // console.log(this.pdf);
            },
            getComplex(code) {
                // console.log(code, 'asdasdasd')
                var clean_code = code.replace(/['"]+/g, '').replace('ЖК', '').replace(/\s/g, '');
                var tran_code = this.cyrTolat(clean_code);
                this.complex = tran_code.toLowerCase();
                // console.log(this.complex, 'COMPLEX ASADASD')
                if (this.complex == 'jazz') {
                    this.complex = 'jazzkvartal'
                } else if (this.complex == 'millenniumpark') {
                    this.complex = 'mpark'
                } else if (this.complex == 'nurlidala') {
                    this.complex = 'nurly-dala'
                } else if (this.complex == 'remizovkaprivateresidences') {
                    this.complex = 'remizovka'
                } else if (this.complex == 'orionii') {
                    this.complex = 'orion'
                } else if (this.complex == 'orioniii') {
                    this.complex = 'orion-3'
                } else if (this.complex == 'soho') {
                    this.complex = 'soho2'
                } else if (this.complex == 'landmark3ochered') {
                    this.complex = 'landmark'
                } else if (this.complex == 'landmark2ochered') {
                    this.complex = 'landmark'
                } else if (this.complex == 'landmark4ochered') {
                    this.complex = 'landmark'
                } else if (this.complex == 'al’farabi27') {
                    this.complex = 'alfarabi27';
                } else if (this.complex == 'rocet') { // ТЕСТОВЫЕ ЖК
                    this.complex = 'alfarabi27';
                } else if (this.complex == 'roketa') { // ТЕСТОВЫЕ ЖК
                    this.complex = 'soho';
                } else if (this.complex == 'roket') { // ТЕСТОВЫЕ ЖК
                    this.complex = 'kohota';
                } else if (this.complex == 'aktau') { // ТЕСТОВЫЕ ЖК
                    this.complex = 'aqualina';
                } else if (this.complex == 'shimkent') { // ТЕСТОВЫЕ ЖК
                    this.complex = 'shahristan';
                } else if (this.complex == 'rivieraplus') {
                    this.complex = 'riviera-plus';
                } else if (this.complex == 'adamantplus') {
                    this.complex = 'adamant-plus';
                } else if (this.complex == 'auezovcitypro' ) {
                    this.complex = 'auezov-city-pro';
                } else if (this.complex == 'parkvillegardenline' || this.complex == 'parkvillesunline') {
                    this.complex = 'parkville';
                } else if (this.complex == 'adamantlife') {
                    this.complex = 'adamant-life';
                } else if (this.complex == 'beneluxaclub' || this.complex == 'beneluxcclub' || this.complex == 'beneluxbclub' || this.complex == 'beneluxdclub') {
                    this.complex = 'benelux';
                } else if (this.complex == 'vesper1ochered') {
                    this.complex = 'vesper'
                }
                // console.log(clean_code, tran_code, this.complex);
                if (this.projectItems != null) {
                    this.getComplexData();
                }
            },
            getComplexData() {
                // console.log(this.projectItems, this.complex);
                var filterComplex = this.projectItems.filter(item => {
                    return item.project_name.slug == this.complex
                });
                if (filterComplex.length > 0) {
                    this.complexData = filterComplex[0];
                }
                
                // console.log(filterComplex)
            },
            cyrTolat(text) {
                return cyrillicToTranslit().transform(text, "_").replace(/!/g,'').replace(/:/g,'').replace(/–/g,'').replace(/-/g,'').replace(/«/g,'').replace(/»/g,'').replace(/,/g,'').toLowerCase();
            },
            sendToFavorite(id) { // Добавление квартиры в избранное
                // console.log(id, 'arr flat favorite', localStorage.getItem('favorite_flats'));
                // Получаем уже хранившиеся квартиры если есть из LocalStorage
                var exist = localStorage.getItem('favorite_flats');
                exist = exist ? exist.split(',') : [];
                // Проверяем есть ли уже такая квартира в Storage
                var finder = exist.find(item => item == id);
                // console.log(finder, 'НАЛИЧИЕ');

                if (finder == undefined) {
                    exist.push(id);
                    localStorage.setItem('favorite_flats', exist);
                    // this.$store.commit('setFavoriteCount', exist.length);
                    // console.log(exist);
                } else {
                    var filterExist = exist.filter(item => {
                        return item != id
                    })
                    localStorage.setItem('favorite_flats', filterExist);
                    // this.$store.commit('setFavoriteCount', filterExist.length);
                    // console.log(exist);
                }
            },
            checkProjectFavorite(id) {
                var items = localStorage.getItem('favorite_flats');
                items = items ? items.split(',') : [];
                // this.$store.commit('setFavoriteCount', items.length);
                var finder = items.find(item => item == id);
                // console.log(finder)
                if (finder != undefined) {
                    return true
                } else {
                    return false
                }
            },
            checkerClass(event) {
                event.currentTarget.classList.toggle('active');
            },
            addCardIDtoStorage(id) { // добавляем id квартиры в хранилище для отправки в онлайн покупки или же вывода в блок вы уже посищяли данные страницы
                // console.log(id, 'arr flat favorite', localStorage.getItem('favorite_flats'));
                var exist = localStorage.getItem('viewed_flats');
                exist = exist ? exist.split(',') : [];
                var finder = exist.find(item => item == id);
                if (finder == undefined) {
                    exist.push(id);
                    localStorage.setItem('viewed_flats', exist);
                }
                // console.log(exist, localStorage.getItem('viewed_flats'), 'STORAGE FULL');
            },
            buildFormDataParams(arr) {
                // console.log(arr, 'forms');
                this.formDataParams = {
                    'flatID': arr.id,
                    'complex': arr.complexName,
                    'room': arr.rooms,
                    'size': arr.area,
                    'price': arr.meterPrice,
                    'floor': arr.floor,
                    'number': arr.number,
                    'block': arr.blockName,
                }
            },
            linkToLogin(url, method) {
                // console.log(url);
                var exist = localStorage.getItem('favorite_flats');
                exist = exist ? exist.split(',') : [];
                // var url = 'https://bazis-a.rocketfirm.net';
                var favoriteUrl;
                if (method == 'book') {
                    ym(57579163,'reachGoal','btn_book_flat_card');
                } else if (method == 'by') {
                    ym(57579163,'reachGoal','btn_by_flat_card')
                }
                if (exist.length > 0) {
                    favoriteUrl = '&favoritesFlats=' + exist.join(',');
                    // console.log(exist, favoriteUrl);
                    window.open(
                        url + favoriteUrl,
                        '_blank'
                    );
                } else {
                    window.open(
                        url,
                        '_blank'
                    );
                }
            },
            checkConfirmPurchase(param, code, blockName) {
                // console.log(param, code, blockName)
                if (code != 'DSV' && code != 'LDM' && code != 'SOH' && code != 'MNC') {
                    blockName = this.getNumbersOfString(blockName);
                } else if (code == 'DSV') { 
                    blockName = parseInt(this.getNumbersOfBlockDiscovery(blockName));
                } else if (code == 'LDM') {
                    blockName = parseInt(this.getNumbersOfBlockLandmark(blockName));
                } else if (code == 'SOH') {
                    blockName = this.getNumbersOfBlockSoho(blockName);
                } else if (code == 'MNC') {
                    blockName = this.getNumbersOfBlockMonaco(blockName);
                }
                // console.log(blockName, this.blockPart)

                if (param == 'book') {
                    if (code == 'AKV') { // Настройка кнопок Акварель
                        if (blockName == '25' || blockName == '26' || blockName == '27' || blockName == '28') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (code == 'RPR') { // Настройка кнопок Remizovka
                        if (blockName == '12' || blockName == '15' || blockName == '17') {
                            return true;
                        } else {
                            return false;
                        }
                    } 
                    // ASTANA
                    else if (code == 'DSV') { // Настройка кнопок Discovery
                        if (blockName == '4') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (code == 'LDM') { // Настройка кнопок Landmark
                        // console.log(this.blockPart, 'asdasdasdasdas')
                        if (this.blockPart == 3) {
                            if (blockName == '1') {
                                return true;
                            } else {
                                return false;
                            }
                        } else if (this.blockPart == 4) {
                            if (blockName == '1' || blockName == '2' || blockName == '3') {
                                return true;
                            } else {
                                return false;
                            }
                        }
                        
                    } else if (code == 'MNC') { // Настройка кнопок Monaco
                        if (blockName == '5') {
                            if (this.blockPart == 'Б-С5-1') {
                                return true;
                            }
                        } else {
                            return false;
                        }
                        
                    } else if (code == 'SOH') { // Настройка кнопок Soho
                        if (blockName == '2A') {
                            if (this.blockPart == 'А1' || this.blockPart == 'А2' || this.blockPart == 'А3' || this.blockPart == 'А4' || this.blockPart == 'А5' || this.blockPart == 'А6' || this.blockPart == 'А7' || this.blockPart == 'А8' || this.blockPart == 'А9') {
                                return true;
                            } else {
                                return false;
                            }
                        } else if (blockName == '2А') {
                            if (this.blockPart == 'А1' || this.blockPart == 'А2' || this.blockPart == 'А3' || this.blockPart == 'А4' || this.blockPart == 'А5' || this.blockPart == 'А6' || this.blockPart == 'А7' || this.blockPart == 'А8' || this.blockPart == 'А9') {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    } 
                } else if (param == 'by') {
                    // ALMATY
                    if (code == 'AKV') { // Настройка кнопок Акварель
                        if (blockName == '25' || blockName == '26' || blockName == '27' || blockName == '28') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (code == 'PRV') { // Настройка кнопок Primavera
                        if (blockName == '1' || blockName == '2') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (code == 'RPR') { // Настройка кнопок Remizovka
                        return false;
                    } 
                    // ASTANA
                    else if (code == 'DSV') { // Настройка кнопок Discovery
                        if (blockName == '4') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (code == 'LDM') { // Настройка кнопок Landmark
                        if (this.blockPart == 4) {
                            if (blockName == '1' || blockName == '2' || blockName == '3') {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    } else if (code == 'MNC') { // Настройка кнопок Monaco
                        if (blockName == '5') {
                            if (this.blockPart == 'Б-С5-1') {
                                return true;
                            }
                        } else {
                            return false;
                        }
                    } else if (code == 'SOH') { // Настройка кнопок Soho
                        if (blockName == '2A') {
                            if (this.blockPart == 'А1' || this.blockPart == 'А2' || this.blockPart == 'А3' || this.blockPart == 'А4' || this.blockPart == 'А5' || this.blockPart == 'А6' || this.blockPart == 'А7' || this.blockPart == 'А8' || this.blockPart == 'А9') {
                                return true;
                            } else {
                                return false;
                            }
                        } else if (blockName == '2А') {
                            if (this.blockPart == 'А1' || this.blockPart == 'А2' || this.blockPart == 'А3' || this.blockPart == 'А4' || this.blockPart == 'А5' || this.blockPart == 'А6' || this.blockPart == 'А7' || this.blockPart == 'А8' || this.blockPart == 'А9') {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    }
                } else {
                    return false;
                }
            },
            openFormMailFlatsCRM() {
                this.$store.commit('openFormMailFlatsCRM', true)
            },
            closeFormMailFlatsCRM() {
                this.$store.commit('openFormMailFlatsCRM', false)
            },
            isMobileCheck() {
                if (window.innerWidth < 767) {
                    this.isMobile = true
                }
            },
            handleResize() {
                if (window.innerWidth < 767) {
                    this.isMobile = true
                } else {
                    this.isMobile = false
                }
            }, 
            checkResize() {
                window.addEventListener('resize', this.handleResize)
                this.handleResize();
            },
            CapitalizeID(s) {
                if (typeof s !== 'string') return ''
                return s.charAt(0).toUpperCase() + s.slice(1)
            },
        },
        beforeRouteEnter(to, from, next) {
            if (store.state.projectItems == null) {
                store.dispatch('getProjectsItems');
            }
            axios.post(window.CRMProxy + '/v1/apartments', { apartmentIds: [to.params.id] })
                .then((response) => {
                    if (response.data.data != 0) {
                        next(vm => {
                            vm.cardData = response.data.data[0];
                            vm.addCardIDtoStorage(vm.cardData.id);
                            vm.getIdPDF(vm.cardData.images);
                            vm.getComplex(vm.cardData.complexName);
                            vm.isMobileCheck();
                            vm.checkResize();
                            vm.$store.commit('removePageLoaderImg');
                            vm.$parent.$refs.topProgress.done();
                        });
                    } else {
                        next('/flats');
                    }
                })
                .catch((error) => {
                    console.error('getApartments error:', error && error.response ? error.response.status : error);
                    next('/flats');
                });
        },
        beforeRouteUpdate (to, from, next) {
            next();
            this.$router.go();
        },
        beforeCreate() {
            document.body.dataset.page = 'flats-crm-card';
        },
        created () {
        },
        mounted () {
            this.$store.watch(
                (state) => state.projectItems,
                (newValue) => {
                    if (newValue) {
                       this.getComplexData();
                    }
                }
            );
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-crm/flats-crm-card.scss';
    @import '@/styles/components/flats-crm/flats-crm-card-payment.scss';
    @import '@/styles/components/flats-crm/respond/flats-crm-card-respond.scss';
    @import '@/styles/components/flats-crm/respond/flats-crm-card-payment-respond.scss';
    // @import '@/styles/components/flats-page/flats-card.scss';
    // @import '@/styles/components/flats-page/respond/flats-card-respond.scss';
</style>